export function camelToDashCase(input: string) {
  return input.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

export function dashToCamelCase(input: string) {
  return input.replace(/-([a-zA-Z])/g, (_, letter) => letter.toUpperCase());
}
